// @ts-check
import { computed, ref } from 'vue'
import * as Sentry from '@sentry/browser'
import { useRouter } from 'vue-router/composables'

import { useActions, useGetters } from 'vuex-composition-helpers/dist'

export function useSignedData (params = {}) {
  const router = useRouter()
  const { envelope, getConfig } = useGetters({ envelope: 'envelope', getConfig: 'config' })
  const { getEnvelope } = useActions({ getEnvelope: 'getEnvelope' })

  const loading = ref(false)
  const auth = ref({
    required: false,
    title: null,
    incorrect: false
  })
  const status = computed(() => envelope.value.status)
  const companyName = computed(() => getConfig.value('company_name'))

  function updateData (password) {
    loading.value = true
    getEnvelope({ password, ...params })
      .then(() => {
        auth.value = {
          required: false,
          title: null,
          incorrect: false
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          auth.value = {
            required: true,
            title: error.response.data.title,
            incorrect: !!password
          }
        } else if (error.response) {
          Sentry.captureException(error.response)

          router.push({
            name: 'PageError',
            params: {
              errorMessage: error.response.data.message,
              errorCode: error.response.status
            }
          })
        } else {
          Sentry.captureException(error, {
            extra: error
          })

          router.push({
            name: 'PageError',
            params: {
              errorMessage: error.message || error,
              errorCode: '0'
            }
          })
        }
      })
      .finally(() => {
        loading.value = false
      })
  }

  if (!envelope.value.id) {
    updateData()
  }

  return {
    status,
    companyName,
    auth,
    loading,
    updateData
  }
}
